import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

type SetTournamentIntentPayload = {
  intent: boolean;
};

export default function useSetTournamentIntent() {
  const mutation = useMutation(async (payload: SetTournamentIntentPayload) => {
    const response = await ChessRestClient.post(
      'v1/set_tournament_intent_for_user/',
      payload,
    );
    return response.data;
  });

  return {
    ...mutation,
    isLoading: mutation.isLoading,
  };
}
